var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-button"},[_c('div',{class:_vm.classNames,on:{"click":_vm.buttonClicked}},[(_vm.isLoading)?_c('i',{staticClass:"fa-spin fa-refresh fa"}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c4c5e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/buttons/FormButton.vue
// module id = null
// module chunks = 